import { useSearchParams } from 'react-router-dom'

export default function Success() {
  const [searchParams] = useSearchParams()
  const sessionId = searchParams.get('session_id')

  return (
    <div className="max-w-2xl mx-auto text-center py-12">
      <div className="card">
        <img
          src="/images/logo.png"
          alt="School Lunch Angels"
          className="h-24 w-auto mx-auto mb-6"
        />
        <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-10 h-10 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-gray-800 mb-4">
          Registration Complete!
        </h1>

        <p className="text-gray-600 mb-6">
          Thank you for registering! A confirmation email has been sent to your
          email address with all the details.
        </p>

        <div className="bg-gray-50 rounded-lg p-4 mb-6">
          <h2 className="font-semibold text-gray-700 mb-2">What's Next?</h2>
          <ul className="text-left text-gray-600 space-y-2">
            <li className="flex items-start gap-2">
              <span className="text-green-500">✓</span>
              Check your email for a confirmation receipt with event details
            </li>
            <li className="flex items-start gap-2">
              <span className="text-green-500">✓</span>
              Contact us at secretary@schoollunchangels.org if you have questions
            </li>
          </ul>
        </div>

        <div className="bg-sla-green/10 border border-sla-green/30 rounded-lg p-4 mb-6">
          <p className="text-sla-green font-medium">
            You may now close this window.
          </p>
          <p className="text-gray-600 text-sm mt-1">
            Thank you for supporting School Lunch Angels!
          </p>
        </div>

        {sessionId && (
          <p className="text-xs text-gray-400">
            Reference: {sessionId.substring(0, 20)}...
          </p>
        )}
      </div>
    </div>
  )
}
